import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';

/**
 * The `ProjectNamePicker` scaffolder form field (`ui:field: ProjectNamePicker`
 * in the `odoo-project` template of the ludo platform-catalog fork).
 *
 * `FormFieldBlueprint` attaches to the `formFields` input of
 * `api:scaffolder/form-fields`, which the scaffolder plugin provides — hence a
 * module of the `scaffolder` plugin, like the kube-secrets card is a module of
 * `catalog`. The component is loaded lazily, with the scaffolder's own fields.
 */
const projectNamePickerField = FormFieldBlueprint.make({
  name: 'project-name-picker',
  params: {
    field: async () => {
      const { ProjectNamePicker, projectNamePickerValidation } = await import(
        './ProjectNamePicker'
      );
      return createFormField({
        name: 'ProjectNamePicker',
        component: ProjectNamePicker,
        validation: projectNamePickerValidation,
        schema: makeFieldSchema({
          output: z => z.string(),
          uiOptions: z => z.object({}),
        }),
      });
    },
  },
});

export default createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [projectNamePickerField],
});
